import { render } from "./GardenIcon.vue?vue&type=template&id=19c99718"
import script from "./GardenIcon.vue?vue&type=script&lang=js"
export * from "./GardenIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__